import { LinearGradient } from 'expo-linear-gradient';

export default LinearGradient;
